export enum ButtonPressedEnum {
  KEEP = "KEEP",
  CHANGE = "CHANGE",
}

export type ButtonPressedProps = ButtonPressedEnum | null;
